import { brandKitValidator } from "@redotech/redo-model/brand-kit";
import { z } from "zod";

export const getBrandKit = { input: z.null(), output: brandKitValidator };
